<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        อัปโหลดไฟล์
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">อัปโหลดไฟล์</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <h3 class="box-title">ผลการนำเข้าข้อมูลไฟลจัดการข้อมูลอินเทอร์เน็ตประจำที่</h3>
              </div>

              <div class="box-body">
                <div class="wrapper_confirm_promotion">
                  <el-button
                    style="margin-left: 10px;"
                    size="small"
                    type="success"
                    @click="submitUpload"
                  >ยืนยันการนำเข้าข้อมูล</el-button>
                  <el-button
                    style="margin-left: 10px;"
                    size="small"
                    type="primary"
                    @click="cancelUpload"
                  >ยกเลิก</el-button>
                </div>
                <data-tables
                  :data="prepareList"
                  :page-size="5"
                  :pagination-props="{ background: true, pageSizes: [5, 10, 15] }"
                  :table-props="tableProps"
                >
                  <el-table-column
                    sortable="custom"
                    fixed
                    prop="promotion_code"
                    label="รหัสรายการส่งเสริมการขาย"
                    width="150"
                  ></el-table-column>
                  <el-table-column prop="promotion_name_th" sortable="custom" label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)"></el-table-column>
                  <el-table-column prop="promotion_name_en" sortable="custom" label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)"></el-table-column>
                  <el-table-column prop="promotion_technology" sortable="custom" label="ประเภทเทคโนโลยีการให้บริการ"></el-table-column>
                  <el-table-column prop="promotion_type" sortable="custom" label="ชนิดของรายการส่งเสริมการขาย"></el-table-column>
                  <el-table-column prop="start_sale_date_show" sortable="custom" label="วันเริ่มต้นการเสนอขาย" >
                    <template slot-scope="scope" >
                      {{scope.row.start_sale_date_show  === 'Invalid date' ? '':scope.row.start_sale_date_show}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="end_sale_date_show" sortable="custom" label="วันสิ้นสุดการเสนอขาย" >
                    <template slot-scope="scope" >
                      {{scope.row.end_sale_date_show  === 'Invalid date' ? '':scope.row.end_sale_date_show}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="start_service_date_show" sortable="custom" label="วันเริ่มต้นการให้บริการ" >
                    <template slot-scope="scope" >
                      {{scope.row.start_service_date_show  === 'Invalid date' ? '':scope.row.start_service_date_show}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="end_service_date_show" sortable="custom" label="วันสิ้นสุดการให้บริการ" >
                    <template slot-scope="scope" >
                      {{scope.row.end_service_date_show  === 'Invalid date' ? '':scope.row.end_service_date_show}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="promotion_price" sortable="custom" label="ค่าบริการ (บาท)" ></el-table-column>
                  <el-table-column prop="download_speed" sortable="custom" label="ความเร็วดาวน์โหลด Mbps" ></el-table-column>
                  <el-table-column prop="upload_speed" sortable="custom" label="ความเร็วอัปโหลด Mbps" ></el-table-column>
                  <el-table-column label="การให้บริการเสริม (เสียค่าบริการ)">
                    <el-table-column prop="content_service_th" sortable="custom" label="บริการความบันเทิง Contents (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="content_service_en" sortable="custom" label="บริการความบันเทิง Contents (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="mobile_service_th" sortable="custom" label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="mobile_service_en" sortable="custom" label="บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="wifi_service_th" sortable="custom" label="บริการ WiFi/Hotspot (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="wifi_service_en" sortable="custom" label="บริการ WiFi/Hotspot (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="fixed_line_service_th" sortable="custom" label="บริการ Fixed Line (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="fixed_line_service_en" sortable="custom" label="บริการ Fixed Line (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="device_service_th" sortable="custom" label="อุปกรณ์อื่นๆ (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="device_service_en" sortable="custom" label="อุปกรณ์อื่นๆ (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="other_service_th" sortable="custom" label="การให้บริการอื่นๆ (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="other_service_en" sortable="custom" label="การให้บริการอื่นๆ (ภาษาอังกฤษ )" ></el-table-column>
                  </el-table-column>
                  <el-table-column label="การให้บริการเสริม (ฟรี)">
                    <el-table-column prop="privilege_content_th" sortable="custom" label="บริการความบันเทิง Contents (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="privilege_content_en" sortable="custom" label="บริการความบันเทิง Contents (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="privilege_mobile_th" sortable="custom" label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="privilege_mobile_en" sortable="custom" label="บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="privilege_wifi_th" sortable="custom" label="บริการ WiFi/Hotspot (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="privilege_wifi_en" sortable="custom" label="บริการ WiFi/Hotspot (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="privilege_premium_th" sortable="custom" label="บริการพรีเมี่ยม (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="privilege_premium_en" sortable="custom" label="บริการพรีเมี่ยม (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="privilege_device_th" sortable="custom" label="อุปกรณ์อื่นๆ (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="privilege_device_en" sortable="custom" label="อุปกรณ์อื่นๆ (ภาษาอังกฤษ)" ></el-table-column>
                    <el-table-column prop="privilege_other_th" sortable="custom" label="การให้บริการอื่นๆ (ภาษาไทย)" ></el-table-column>
                    <el-table-column prop="privilege_other_en" sortable="custom" label="การให้บริการอื่นๆ (ภาษาอังกฤษ )" ></el-table-column>
                  </el-table-column>
                  <el-table-column prop="internet_per_Mbps" sortable="custom" label="อัตราค่าบริการต่อหน่วย (Mbps)" ></el-table-column>
                  <el-table-column prop="promotion_condition_th" sortable="custom" label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)" ></el-table-column>
                  <el-table-column prop="promotion_condition_en" sortable="custom" label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)" ></el-table-column>
                  <el-table-column prop="promotion_link_url" sortable="custom" label="ลิงก์เว็บไซต์หรือลิงก์ของรายการส่งเสริมฯ" ></el-table-column>
                  <el-table-column prop="promotion_banner" sortable="custom" label="ลิงก์รูปโฆษณาหรือลิงก์รูปรายการส่งเสริมฯ" ></el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions } from "vuex"
export default {
  data() {
    return {
      selectDate: '',
      type: '',
      tableProps: {
        border: true
        // stripe: true,
      },
      data: []
    }
  },
  mounted(){
    //console.log(this.$route.query)
    //this.$store.dispatch('Manage_internet/prepareTable', this.$route.query)
  },
  computed: {
    ...mapState({
      prepareList : store => store.Manage_internet.prepares
    })
  },
  methods: {
    ...mapActions({
      prepare : "Manage_internet/prepareTable",
      insert : "Manage_internet/add_promotion"
    }),
    submitUpload() {
      this.insert(this.prepareList)
    },
    cancelUpload() {
      
      const regex = /Operator\/Manage_internet/
      var currentPath = this.$router.currentRoute.path

      if (regex.test(currentPath)) {
        this.$router.push({ name: 'Operator_Manage_internet' })
      }else{
        this.$router.push({ name: 'Manage_internet' })
      }
    }
  }
};
</script>
